import { FC } from 'react';
import "../../styles.css";
import Hero from "../../components/Hero";
import HowItWorks from '../../components/HowItWorks';
import ValueProps from '../../components/ValueProps';
import UserAnalyzerPage from '../userAnalyzer/useranalyzerpage';
import { useAuth } from '../../auth/authContext';

const Home: FC = () => {
    const { user } = useAuth();

    return (
        <>
            <main>
                <Hero />
                {user ? <UserAnalyzerPage /> : "" }
                {user ? "" : <HowItWorks />}
                {user ? "" : <ValueProps />}
            </main>
        </>
    );
}

export default Home;